module.exports = __webpack_public_path__ + "img/banner.ff901442.png";